import React, { useEffect, useRef, useState } from "react";

const DmsInActionSection = ({ image }) => {
  const sectionRef = useRef();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setIsVisible(true);
      },
      { threshold: 0.3 }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="dms-in-action-section py-5 bg-white" ref={sectionRef}>
      <div className="container text-center">
        <h2 className="fw-bold mb-4 text-dark">DMS in Action</h2>
        <img
          src={image}
          alt="DMS in Action"
          className={`img-fluid rounded ${isVisible ? "slide-in-left" : ""}`}
          style={{
            maxWidth: "100%",
            opacity: isVisible ? 1 : 0,
            transition: "all 0.8s ease-out",
          }}
        />
      </div>
    </section>
  );
};

export default DmsInActionSection;
